
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';
  import {TimelineInteractionModel, TimelineModel} from '@/models/timeline.model';
  import {challengeModule, userModule} from '@/utils/store-acessor';
  import {validators} from '@/utils/validations';
  import moment from 'moment-timezone';
  import {ChallengeModel} from '@/models/challenge.model';

  @Component({})
  export default class TimelineItem extends Vue {
    @Prop({required: true}) timeline!: TimelineModel;
    @Prop({required: true, default: false}) canInteract!: boolean;
    @challengeModule.Getter('hasPrivilegeAccess') isUserWithPrivileges!: boolean;
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    @userModule.Getter('timezone') timezone!: string;

    model = new TimelineInteractionModel();
    rules = validators;
    loading = false;
    destroyLoader = false;
    snackbarVisibility = false;
    snackbarColor: 'green' | 'red' = 'green';
    snackbarMessage: string = '';
    now = moment().format('MMM. D YYYY, HH:mm a');

    formatDate(date: string): string {
      return moment(date)
              .tz(this.timezone)
              .format('MMM. D YYYY, HH:mm a')
              .toString()
    }

    onTimelineInteraction(id: number) {
      this.$router.push({
        name: 'timeline-interaction',
        params: {id: `${id}`}
      });
    }

    isActive(): boolean {
      const start = moment(this.timeline.start_at).tz(this.timezone);
      const finish = moment(this.timeline.finish_at).tz(this.timezone);
      const current = moment(new Date()).tz(this.timezone);
      if (!!this.timeline.finish_at) {
        return start.isSameOrBefore(current) && finish.isSameOrAfter(current);
      } else {
        return start.isSameOrBefore(current)
      }
    }

    notYetStarted(): boolean {
      const start = moment(this.timeline.start_at).tz(this.timezone);
      const current = moment(new Date()).tz(this.timezone);
      return start.isSameOrAfter(current)
    }

    private onToastMessage(message: string, color: 'green' | 'red') {
      this.snackbarColor = color;
      this.snackbarVisibility = true;
      this.snackbarMessage = message;
    }
  }
